module.exports = "./img/b805391d75daf393ac40b488d94e2a04.jpg";